import { render, staticRenderFns } from "./LicenseList.vue?vue&type=template&id=27f0f896&scoped=true&"
import script from "./LicenseList.vue?vue&type=script&lang=ts&"
export * from "./LicenseList.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseList.vue?vue&type=style&index=0&id=27f0f896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0f896",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VSelect,VTextField})
